var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockKyc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.016 9.448V6.616A6.02 6.02 0 0 0 12 .6a6.024 6.024 0 0 0-6.016 6.016v2.832a2.716 2.716 0 0 0-2.48 2.703v3.377c0 4.34 3.528 7.872 7.868 7.872h1.256c4.34 0 7.868-3.532 7.868-7.872V12.15a2.716 2.716 0 0 0-2.48-2.703M8.588 6.616c.187-4.521 6.637-4.52 6.824 0v2.82H8.588zm2.46 10.116c-1.404-.916-.719-3.155.952-3.14 1.671-.014 2.357 2.223.952 3.14a.4.4 0 0 0-.176.332v1.404c-.026 1.022-1.525 1.024-1.552 0v-1.404a.4.4 0 0 0-.176-.332"
})));
export default SvgLockKyc;